import React from 'react';
import { SidePanelProps } from './SidePanel.types';

type SidePanelContextProps = {
  onCloseButtonClick?: () => void;
  onHelpButtonClick?: () => void;
  skin?: SidePanelProps['skin'];
  isDraggable?: SidePanelProps['draggable'];
};

export const SidePanelContext = React.createContext(
  {} as SidePanelContextProps,
);
